// extracted by mini-css-extract-plugin
export default {"LogoWrapper":"Logo_LogoWrapper__15t2r"};